<template>
  <div class="sip-collapse">
    <div class="sip-collapse__main">
      <div class="sip-collapse__item">
        <span class="sip-collapse__name">{{ this.$t('pbx.sip-account.form.field.login') }}:</span>
        <span class="sip-collapse__value">{{ login }}</span>
      </div>

      <b-collapse id="collapse" v-model="is_collapse" class="sip-collapse__content">
        <div class="sip-collapse__item">
          <span class="sip-collapse__name">
            {{ this.$t('pbx.sip-account.form.field.password') }}:
          </span>
          <span class="sip-collapse__value">{{ password }}</span>
        </div>
      </b-collapse>
    </div>

    <div class="sip-collapse__controls">
      <icon
        :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
        class="sip-collapse__controls-icon"
        @click="is_collapse = !is_collapse"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      login: {
        type: String,
        default: ''
      },
      password: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      is_collapse: false
    })
  };
</script>

<style lang="scss" scoped>
  .sip-collapse {
    display: flex;
    width: 100%;

    &__main {
      flex: auto;
    }

    &__controls {
      margin-left: 15px;
      align-self: center;
    }

    &__controls-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__content {
      .sip-collapse__item {
        margin-top: 10px;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: #a0a0a0;
    }
  }
</style>
